export default __webpack_public_path__ + "static/media/circled-less.e1f42e69.svg";